module.exports = __webpack_public_path__ + "img/title-ld.4bd9f5cf.png";